// extracted by mini-css-extract-plugin
module.exports = {"panelBody":"Tabs_panelBody__1GWuG","tabHeading":"Tabs_tabHeading__3znuu","navTabs":"Tabs_navTabs__1drPC","tab":"Tabs_tab__2xwq-","tabPanel":"Tabs_tabPanel__2KMbZ"};